import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Big from 'big.js';

import { useCampaignContribute } from 'context/CampaignContribute';
import config from 'config';

const CampaignContributeElementsProvider = ({ accountId, publicKey, children }) => {
  const { estimatedTotal, contribution } = useCampaignContribute();
  const stripeAmount = Big(estimatedTotal ?? 0)
    .times(100)
    .toNumber();

  const stripe = useMemo(() => {
    if (!publicKey || !accountId) return null;
    return loadStripe(publicKey, { stripeAccount: accountId });
  }, [accountId, publicKey]);

  // The stripe elements can't be included without a non-zero amount so bail here
  if (!stripeAmount > 0) {
    return children;
  }

  const isPledge = contribution.type === 'pledge';
  const stripeOptions = config('/stripe/defaultProviderOptions');
  if (isPledge) {
    stripeOptions.mode = 'setup';
    stripeOptions.setupFutureUsage = 'off_session';
  } else {
    stripeOptions.mode = 'payment';
    stripeOptions.amount = stripeAmount;
  }

  return (
    <Elements stripe={stripe} options={stripeOptions}>
      {children}
    </Elements>
  );
};

CampaignContributeElementsProvider.propTypes = {
  publicKey: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CampaignContributeElementsProvider;
